var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "our-people__grid" }, [
    _c("div", { staticClass: "columns is-mobile" }, [
      _c("div", { staticClass: "column is-8-desktop is-7-mobile" }, [
        _c(
          "div",
          { staticClass: "columns is-mobile is-multiline" },
          _vm._l(_vm.people, function(person) {
            return _c(
              "div",
              {
                key: person.ID,
                staticClass: "column is-4-desktop is-6-mobile",
                on: {
                  click: function($event) {
                    _vm.selectPerson(person)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "person_card",
                    class: { active: person.ID === _vm.selectedPerson.ID }
                  },
                  [
                    _c("img", { attrs: { src: person.image } }),
                    _vm._v(" "),
                    _c("h2", { staticClass: "person_card__name" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(person.post_title) +
                          "\n            "
                      )
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column is-4-desktop is-5-mobile" }, [
        _c("div", { staticClass: "selected_people" }, [
          _c(
            "div",
            {
              ref: "selectedPeopleContainer",
              staticClass: "selected_people__content"
            },
            [
              _vm.selectedPerson
                ? _c("h4", { staticClass: "selected_people__position" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedPerson.position) +
                        "\n          "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedPerson
                ? _c("h2", { staticClass: "selected_people__title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedPerson.post_title) +
                        "\n          "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.selectedPerson.post_content) }
              })
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2747614c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2747614c","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/our-people/OurPeople.vue
// module id = 200
// module chunks = 0